import { createContext } from "react";

const DF_OT0086Context = createContext();

export { DF_OT0086Context };
